{
  "user-profile-page": {
    "meta": {
      "title": "Profil",
      "description": "Profil uživatele"
    }
  }
}
